<template>
	<div class="company-container">
		<div class="company-content">
			<div class="tab-container">
				<div class="cjt-tabs">
					<div class="cjt-tabs__header">
						<div class="cjt-tabs__nav-wrap">
							<div
								v-for="(tab, index) in maintenanceTabs"
								:key="index"
								class="cjt-tabs__item"
								:class="{ active: activeTabIndex === index }"
								@click="changeMaintenanceTab(index)"
							>
								<span class="cjt-tabs__item-text">{{ tab.name }}</span>
								<span v-if="tab.isHot" class="tag-member-mini tag-member--vip">HOT</span>
							</div>

							<!-- <div class="cjt-tabs-more">
									<router-link to="#">
										更多
										<i class="el-icon-arrow-right"></i>
									</router-link>
								</div> -->
						</div>
					</div>
					<div class="cjt-tabs__container">
						<transition name="fade-transform" mode="out-in">
							<div :key="activeTabIndex" class="cjt-tabs__content">
								<!-- 临期提醒内容 -->
								<div v-if="activeTabIndex === 0" class="qualificationQuery-search">
									<el-form ref="searchForm" :model="searchForm" label-width="150px" class="searchForm">
										<el-form-item label="企业名称" prop="companyName">
											<el-input v-model.trim="searchForm.companyName" placeholder="请输入企业名称" clearable></el-input>
										</el-form-item>
										<el-form-item label="统一信用代码" prop="companyCode">
											<el-input v-model.trim="searchForm.companyCode" placeholder="请输入统一信用代码" clearable></el-input>
										</el-form-item>
									</el-form>
									<div class="search-button-box">
										<el-button class="search" @click="search">查询</el-button>
										<el-button class="reset" @click="reset">重置</el-button>
									</div>
								</div>
								<div v-if="activeTabIndex === 1" class="qualificationQuery-search">
									<el-form ref="searchAdvancedForm" :model="searchAdvancedForm" label-width="150px" class="searchForm">
										<el-form-item label="注册资金" prop="registeredCapital" class="money-box">
											<div class="limit-box-out">
												<el-radio-group v-model="searchAdvancedForm.registeredCapital" @change="handleRadioChange">
													<el-radio-button v-for="item in cities" :key="item.value" :label="item.value">
														{{ item.label }}
													</el-radio-button>
												</el-radio-group>
												<div class="limit-box-inner">
													<div class="limit-box">
														<el-input
															v-model.trim="searchAdvancedForm.registeredCapitalStart"
															placeholder="最低金额"
															:disabled="searchAdvancedForm.registeredCapital !== ''"
															@input="handleInputChange"
															clearable
														></el-input>
														<span>万</span>
													</div>
													<span class="limit-fg">--</span>
													<div class="limit-box">
														<el-input
															v-model.trim="searchAdvancedForm.registeredCapitalEnd"
															placeholder="最高金额"
															:disabled="searchAdvancedForm.registeredCapital !== ''"
															@input="handleInputChange"
															clearable
														></el-input>
														<span>万</span>
													</div>
												</div>
											</div>
										</el-form-item>
										<el-form-item label="企业名称" prop="companyName">
											<el-input v-model.trim="searchAdvancedForm.companyName" placeholder="请输入企业名称" clearable></el-input>
										</el-form-item>
										<el-form-item label="成立时间" prop="region" class="search-time-box">
											<el-date-picker
												v-model="validityTimeEnd"
												type="daterange"
												range-separator="至"
												start-placeholder="开始日期"
												end-placeholder="结束日期"
												value-format="yyyy-MM-dd"
											></el-date-picker>
										</el-form-item>
										<el-form-item label="企业类型" prop="companyType">
											<el-select v-model="searchAdvancedForm.companyType" placeholder="请选择企业类型" clearable>
												<el-option
													v-for="item in companyTypeList"
													:key="item.code"
													:label="item.name"
													:value="item.code"
												></el-option>
											</el-select>
										</el-form-item>
										<el-form-item label="持证数量" prop="certNum">
											<el-input v-model.trim="searchAdvancedForm.certNum" v-oneToTenInteger></el-input>
										</el-form-item>
										<el-form-item label="企业所在市县" prop="registeredAddress">
											<!-- <el-select v-model="searchAdvancedForm.registeredAddress" placeholder="请选择企业所在市县" clearable>
												<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
											</el-select> -->
											<el-cascader
												ref="Address"
												v-model="addressList"
												:options="divisionHbDictList"
												:props="cityDictProps"
												style="width: 100%"
												@change="addressAfterChange"
											></el-cascader>
										</el-form-item>
										<el-form-item label="法人代表" prop="legalPerson">
											<el-input v-model.trim="searchAdvancedForm.legalPerson" placeholder="请输入法人代表" clearable></el-input>
										</el-form-item>
										<el-form-item label="资质类别" prop="certType">
											<el-select v-model="searchAdvancedForm.certType" placeholder="请选择资质类别" clearable>
												<el-option
													v-for="item in certTypeList"
													:key="item.code"
													:label="item.name"
													:value="item.code"
												></el-option>
											</el-select>
										</el-form-item>
										<el-form-item label="企业人员" prop="certificateType">
											<el-select v-model="searchAdvancedForm.certificateType" placeholder="资质类别" filterable clearable>
												<el-option
													v-for="item in personnelMajorDict"
													:key="item.id"
													:label="item.dictValue"
													:value="item.dictCode"
												></el-option>
											</el-select>
										</el-form-item>
									</el-form>
									<div class="search-button-box">
										<el-button class="search" @click="searchAdvanced">查询</el-button>
										<el-button class="reset" @click="resetAdvancedSearch">重置</el-button>
									</div>
								</div>
							</div>
						</transition>
					</div>
					<!-- 热门查询区域--start -->
					<!-- <div class="hot-query-container">
						<div class="hot-query-content">
							<div class="hot-query-list">
								<h3 class="list-title">热门查询</h3>
								<div class="query-items">
									<div class="query-item">
										<div class="icon icon-czz"></div>
										<div class="item-content">
											<h4>查资质</h4>
											<p>查询资质，降低废证风险</p>
										</div>
										<i class="el-icon-arrow-right"></i>
									</div>
									<div class="query-item">
										<div class="icon icon-cfx"></div>
										<div class="item-content">
											<h4>查风险</h4>
											<p>查询资质，降低废证风险</p>
										</div>
										<i class="el-icon-arrow-right"></i>
									</div>
									<div class="query-item">
										<div class="icon icon-cyj"></div>
										<div class="item-content">
											<h4>查业绩</h4>
											<p>查询资质，降低废证风险</p>
										</div>
										<i class="el-icon-arrow-right"></i>
									</div>
									<div class="query-item">
										<div class="icon icon-hyxy"></div>
										<div class="item-content">
											<h4>查行业信用</h4>
											<p>查询资质，降低废证风险</p>
										</div>
										<i class="el-icon-arrow-right"></i>
									</div>
									<div class="query-item">
										<div class="icon icon-cll"></div>
										<div class="item-content">
											<h4>查履历</h4>
											<p>查询资质，降低废证风险</p>
										</div>
										<i class="el-icon-arrow-right"></i>
									</div>
									<div class="query-item">
										<div class="icon icon-zzsy"></div>
										<div class="item-content">
											<h4>资质溯源</h4>
											<p>查询资质，降低废证风险</p>
										</div>
										<i class="el-icon-arrow-right"></i>
									</div>
								</div>
							</div>
						</div>
					</div> -->
					<!-- 热门查询区域--end -->

					<div class="maintenance-list" v-loading="loading">
						<!-- 列表项 -->
						<template v-if="checkTheCompanyList.length > 0">
							<!-- 展示当前有多少条数据 -->
							<div class="notification-title">
								<span class="title-text">
									共有
									<span class="data-count">{{ pageOptions.total }}</span>
									条数据
								</span>
							</div>
							<div v-for="(item, index) in checkTheCompanyList" :key="index" class="notification-item">
								<div class="certificate-info">
									<div class="certificate-name">
										<div>
											<span>{{ item.companyName }}</span>
										</div>
									</div>
									<div class="certificate-detail">
										<div class="detail-item">
											<label>统一信用代码：</label>
											<span class="detail-content">
												{{ item.companyCode ? item.companyCode : '--' }}
											</span>
										</div>
										<div class="detail-item">
											<label>法定代表人：</label>
											<span class="detail-content">{{ item.legalPerson ? item.legalPerson : '--' }}</span>
										</div>
									</div>
									<div class="certificate-detail">
										<div class="detail-item">
											<label>所属地：</label>
											<span class="detail-content">
												{{ item.zoning ? item.zoning : '--' }}
											</span>
										</div>
										<div class="detail-item">
											<label>单位类型：</label>
											<span class="detail-content">{{ item.companyType ? item.companyType : '--' }}</span>
										</div>
									</div>
								</div>
								<div class="certificate-status">
									<span class="collect" @click="toCompanyDetail(item.id)">
										<svg-icon icon-class="view" class="icon" />
										查看
									</span>
									<span class="collect" @click="handleIsCollect(item.id, item.isCollect)">
										<svg-icon v-if="!item.isCollect" icon-class="collect" class="icon" />
										<svg-icon v-else icon-class="collected" class="icon collected" />
										{{ item.isCollect ? '已收藏' : '收藏' }}
									</span>
									<span class="collect" @click="handleIsMonitoring(item.id, item.isMonitoring)">
										<svg-icon v-if="item.isMonitoring" icon-class="monitored" class="icon" />
										<svg-icon v-else icon-class="monitor" class="icon" />
										{{ item.isMonitoring ? '已监控' : '监控' }}
									</span>
								</div>
							</div>
						</template>

						<!-- 数据为空 -->
						<empty-content v-else></empty-content>
					</div>
					<!-- 分页器 -->
					<jr-pagination
						v-if="pageOptions.total > pageOptions.limit"
						:limit="pageOptions.limit"
						:page.sync="pageOptions.page"
						:total="pageOptions.total"
						layout="prev, pager, next"
						prev-text="上一页"
						next-text="下一页"
						@change="handlePaginationChange"
					></jr-pagination>
				</div>
			</div>
		</div>
		<!-- 购买会员弹窗 -->
		<jr-dialog :visible.sync="payVisible" width="840px" :show-btn="false" @close="handleCancel">
			<template slot="title">
				<!-- 自定义弹窗标题 -->
				<h4 class="model-title">
					<span>购买会员</span>
				</h4>
			</template>
			<template slot="content">
				<payment-dialog @payOrderSuccess="handlePayOrderSuccessCallback"></payment-dialog>
			</template>
		</jr-dialog>

		<!-- 登录弹窗 -->
		<jr-dialog
			:visible.sync="loginVisible"
			width="560px"
			:custom-class="'loginDialog'"
			:show-btn="false"
			@loginDone="loginVisible = false"
		>
			<template slot="content">
				<non-login></non-login>
			</template>
		</jr-dialog>
	</div>
</template>

<script>
	import JrDialog from '@/components/Dialog'
	import PaymentDialog from '@/views/memberBenefits/paymentDialog.vue'
	import JrPagination from '@/components/Pagination'
	import NonLogin from '@/components/NonLogin'
	import { pageCompany, pageCompanyAdvance } from '@/api/qualificationQuery/company'
	import { saveUserCollect, removeUserCollect, saveUserMonitoring, removeUserMonitoring } from '@/api/userCenter/index'
	import { COLLECT_TYPE_STATE } from '@/enum/index'
	import { ENUM_COMPANYTYPE_LIST, ENUM_CERTYPE_LIST } from '@/enum/index'
	import { mapDictionaries } from '@/store/dictionary-helper'
	import { recursionDictData } from '@/api/dictionary/index'
	import { mapState, mapGetters } from 'vuex'
	import memberBenefitCheckerMixins from '@/mixins/memberBenefitCheckerMixins'
	import { ENUM_MEMBER_BENEFIT } from '@/enum/memberBenefitRecord'
	export default {
		name: 'SearchCompany',
		components: {
			JrPagination,
			JrDialog,
			PaymentDialog,
			NonLogin
		},
		props: {},
		mixins: [memberBenefitCheckerMixins],
		data() {
			return {
				// 购买会员弹窗
				payVisible: false,
				// 登录弹窗
				loginVisible: false,
				// 查企业Tab数据
				activeTabIndex: 0,
				maintenanceTabs: [
					{ name: '普通查询', isHot: false },
					{ name: '高级查询', isHot: true }
				],
				// 普通查询表单
				searchForm: {
					// 企业名称
					companyName: '',
					// 企业编码
					companyCode: ''
				},
				// 高级查询表单
				searchAdvancedForm: {
					// 注册资金
					registeredCapital: '',
					// 注册资金-最低
					registeredCapitalStart: '',
					// 注册资金-最高
					registeredCapitalEnd: '',
					// 企业名称
					companyName: '',
					// 成立时间-开始
					registeredTimeStart: '',
					// 成立时间-结束
					registeredTimeEnd: '',
					// 企业类型
					companyType: '',
					// 持证数量
					certNum: '',
					// 企业所在省市县
					registeredProvinceCode: '',
					registeredCityCode: '',
					registeredCountyCode: '',
					// 法人代表
					legalPerson: '',
					// 资质类别
					certType: '',
					// 企业人员
					certificateType: ''
				},
				// 日期选择器
				validityTimeEnd: [],
				options: [],
				cities: [
					{
						value: '',
						label: '不限'
					},
					{
						value: '100',
						label: '100万以上'
					},
					{
						value: '500',
						label: '500万以上'
					},
					{
						value: '1000',
						label: '1000万以上'
					},
					{
						value: '5000',
						label: '5000万以上'
					},
					{
						value: '10000',
						label: '1亿以上'
					}
				],
				// 查企业
				checkTheCompanyList: [],
				pageOptions: {
					page: 1,
					limit: 10,
					total: 0
				},
				loading: false,
				companyTypeList: ENUM_COMPANYTYPE_LIST,
				certTypeList: ENUM_CERTYPE_LIST,
				cityDictProps: {
					label: 'dictValue',
					value: 'dictCode',
					children: 'childSysDictionaryList',
					checkStrictly: true
				},
				divisionHbDictList: [],
				// 省级区划
				addressList: []
			}
		},
		computed: {
			...mapGetters(['vipLevel', 'isNormalVip', 'isVip', 'isSVip']),
			...mapDictionaries('dictionary', ['personnelMajorDict']),
			...mapState({
				token: state => state.user.token
			})
		},
		watch: {},
		created() {},
		mounted() {
			if (this.$route.query && this.$route.query.value) {
				if (this.token) {
					if (this.$route.query.isHight === 'true') {
						this.searchAdvancedForm.companyName = this.$route.query.value
						this.activeTabIndex = 1
					} else {
						this.searchForm.companyName = this.$route.query.value
					}
				} else {
					this.loginVisible = true
				}
			}
			// 分页查询所有注册企业信息 (网厅)
			this.handleGetHbDivision()

			// 判断当前没有登录的情况下,调取新的接口，并只查询10条数据
			if (!this.token) {
				this.getNoLoginPageCompanylist()
			} else {
				if (this.$route.query.isHight === 'true') {
					this.getAdvancePageCompanylist()
				} else {
					this.getPageCompanylist()
				}
			}
		},
		methods: {
			// 查询湖北省行政区划
			handleGetHbDivision() {
				const params = {
					parentId: '420000000000',
					level: '3'
				}
				recursionDictData(params).then(response => {
					const { data } = response
					this.divisionHbDictList.push(data)
				})
			},

			addressAfterChange(val) {
				this.searchAdvancedForm.registeredProvinceCode = val[0]
				this.searchAdvancedForm.registeredCityCode = val[1]
				this.searchAdvancedForm.registeredCountyCode = val[2]
			},
			// 切换注册资金单选框组
			handleRadioChange(value) {
				if (value !== '') {
					this.searchAdvancedForm.registeredCapitalStart = ''
					this.searchAdvancedForm.registeredCapitalEnd = ''
				}
			},

			// 注册资金输入框变化
			handleInputChange() {
				if (this.searchAdvancedForm.registeredCapitalStart || this.searchAdvancedForm.registeredCapitalEnd) {
					this.searchAdvancedForm.registeredCapital = ''
				}
			},
			// 查询所有注册企业信息 (网厅)
			getPageCompanylist() {
				this.loading = true
				let params = {
					page: this.pageOptions.page,
					limit: this.pageOptions.limit,
					companyName: this.searchForm.companyName,
					companyCode: this.searchForm.companyCode
				}

				pageCompany(params)
					.then(res => {
						// console.log(res, 'res')
						this.checkTheCompanyList = res.data.records
						this.pageOptions.total = res.data.total
						this.loading = false
					})
					.catch(err => {
						this.loading = false
					})
			},

			// 查询所有注册企业信息 (网厅，未登录的情况下，默认只查10条数据)
			getNoLoginPageCompanylist() {
				this.loading = true
				let params = {
					page: 1,
					limit: 10
				}

				pageCompany(params)
					.then(res => {
						this.checkTheCompanyList = res.data.records
						this.pageOptions.total = res.data.total
						this.loading = false
					})
					.catch(err => {
						this.loading = false
					})
			},
			// 高级查询所有注册企业信息 (网厅)
			getAdvancePageCompanylist() {
				this.loading = true

				if (this.validityTimeEnd.length > 0) {
					this.searchAdvancedForm.registeredTimeStart = this.validityTimeEnd[0]
					this.searchAdvancedForm.registeredTimeEnd = this.validityTimeEnd[1]
				}

				let params = {
					page: this.pageOptions.page,
					limit: this.pageOptions.limit,
					...this.searchAdvancedForm
				}

				if (params.registeredCapital) {
					params.registeredCapitalStart = params.registeredCapital
				}

				pageCompanyAdvance(params)
					.then(res => {
						this.checkTheCompanyList = res.data.records
						this.pageOptions.total = res.data.total
						this.loading = false
					})
					.catch(err => {
						this.loading = false
					})
			},
			// 查询
			search() {
				// 判断用户是否登录
				if (!this.token) {
					// 提示未登录，不能操作
					this.loginVisible = true
					return
				} else {
					if (this.activeTabIndex === 0) {
						this.getPageCompanylist()
					} else {
						this.getAdvancePageCompanylist()
					}
				}
			},
			// 重置

			reset() {
				// 判断，当前是否登录
				if (!this.token) {
					this.loginVisible = true
					return
				}

				this.searchForm = {
					// 企业名称
					companyName: '',
					// 企业编码
					companyCode: ''
				}
				this.getPageCompanylist()
			},

			// 高级查询
			async searchAdvanced() {
				if (!this.token) {
					this.loginVisible = true
					return
				}
				const isValid = await this.validateMemberBenefit(ENUM_MEMBER_BENEFIT.GJCX_FILER)
				if (!isValid) {
					this.payVisible = true
					return
				}
				this.getAdvancePageCompanylist()
			},
			// 重置
			resetAdvancedSearch() {
				if (!this.token) {
					this.loginVisible = true
					return
				}
				this.validityTimeEnd = []
				this.addressList = []
				this.searchAdvancedForm = {
					// 注册资金
					registeredCapital: '',
					// 注册资金-最低
					registeredCapitalStart: '',
					// 注册资金-最高
					registeredCapitalEnd: '',
					// 企业名称
					companyName: '',
					// 成立时间-开始
					registeredTimeStart: '',
					// 成立时间-结束
					registeredTimeEnd: '',
					// 企业类型
					companyType: '',
					// 持证数量
					certNum: '',
					// 企业所在省市县
					registeredProvinceCode: '',
					registeredCityCode: '',
					registeredCountyCode: '',
					// 法人代表
					legalPerson: '',
					// 资质类别
					certType: '',
					// 企业人员
					certificateType: ''
				}
				this.getAdvancePageCompanylist()
			},

			// 切换Tab
			changeMaintenanceTab(index) {
				this.activeTabIndex = index
			},
			// 分页
			handlePaginationChange(pager) {
				if (!this.token) {
					this.pageOptions.page = 1
					this.loginVisible = true
					return
				}
				const { page, limit } = pager
				this.pageOptions.page = page
				this.pageOptions.limit = limit
				this.getPageCompanylist()
			},
			toCompanyDetail(val) {
				if (!this.token) {
					this.loginVisible = true
					return
				} else {
					const routeData = this.$router.resolve({
						name: 'SearchCompanyDetail',
						query: {
							id: val
						}
					})
					window.open(routeData.href, '_blank')
				}
			},
			// 收藏与取消收藏
			handleIsCollect(id, flag) {
				if (!this.token) {
					this.loginVisible = true
					return
				}
				if (flag) {
					this.handleRemoveCollect(id)
				} else {
					this.handleCollect(id)
				}
			},
			handleCollect(id) {
				const params = {
					collectIds: [id],
					collectType: COLLECT_TYPE_STATE.ENTERPRISE
				}
				saveUserCollect(params).then(res => {
					this.$message.success('收藏成功')
					this.getPageCompanylist()
				})
			},
			handleRemoveCollect(id) {
				const params = {
					collectIds: [id],
					collectType: COLLECT_TYPE_STATE.ENTERPRISE
				}
				removeUserCollect(params).then(res => {
					this.$message.success('已取消收藏')
					this.getPageCompanylist()
				})
			},
			// 监控与取消监控
			handleIsMonitoring(id, flag) {
				if (!this.token) {
					this.loginVisible = true
					return
				}
				if (!this.isVip && !this.isSVip) {
					this.$message.error('暂不是高级会员，请先购买会员')
					return
				}
				if (flag) {
					this.handleRemoveMonitor(id)
				} else {
					this.handleMonitor(id)
				}
			},
			handleMonitor(id) {
				const params = {
					monitoringIds: [id],
					monitoringType: COLLECT_TYPE_STATE.ENTERPRISE
				}
				saveUserMonitoring(params).then(response => {
					const { code, message } = response

					if (code !== 200) {
						// 这里主要处理以6开头的状态码信息，校验会员等级、会员权益等
						this.$modal.msgWarning(message)
					} else {
						this.$modal.msgSuccess('监控成功')
						this.getPageCompanylist()
					}
				})
			},
			handleRemoveMonitor(id) {
				const params = {
					monitoringIds: [id],
					monitoringType: COLLECT_TYPE_STATE.ENTERPRISE
				}
				removeUserMonitoring(params).then(response => {
					const { code, message } = response

					if (code !== 200) {
						// 这里主要处理以6开头的状态码信息，校验会员等级、会员权益等
						this.$modal.msgWarning(message)
					} else {
						this.$modal.msgSuccess('已取消监控')
						this.getPageCompanylist()
					}
				})
			},
			// 订单创建成功回调
			handlePayOrderSuccessCallback() {
				this.payVisible = false
				this.$router.push({
					path: '/user/market/order'
				})
			},
			handleCancel() {
				this.payVisible = false
			},
			validateCertNum(value) {
				// 尝试将输入值转换为数字
				const numValue = Number(value)

				// 检查转换结果是否为 NaN
				if (isNaN(numValue)) {
					this.searchAdvancedForm.certNum = 1
					return
				}

				// 只允许输入 1 到 10 之间的整数
				const regex = /^[1-9]$|^10$/
				if (!regex.test(value)) {
					// 如果不匹配，则恢复到上一个有效值
					this.searchAdvancedForm.certNum = Math.min(Math.max(1, Math.floor(this.searchAdvancedForm.certNum)), 10)
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.company-container {
		background-color: #eff6f9;
		.company-content {
			padding-top: 31px;
			.cjt-tabs__header {
				width: $main-page-width;
				margin: 0 auto;
				border-bottom: none;
				margin-bottom: 14px;
				.cjt-tabs__item {
					padding-bottom: 14px;
					position: relative;
					.cjt-tabs__item-text {
						font-size: 20px;
						color: #333333;
					}
					.tag-member-mini {
						height: 18px;
						line-height: 18px;
						position: absolute;
						right: -51px;
						top: -10px;
						padding: 0px 7px;
					}
				}
				.active {
					.cjt-tabs__item-text {
						color: #2671cb;
					}
					&::after {
						width: 40px;
					}
				}
			}
			.hot-query-container {
				height: auto;
				background: none;
				.list-title {
					color: #333;
				}
				.hot-query-content {
					padding-top: 30px;
					background: #fff;
					padding-bottom: 30px;
					.query-items {
						padding-left: 20px;
						padding-right: 10px;
					}
					.list-title {
						padding-left: 20px;
					}
				}
			}
			.cjt-tabs__container {
				min-height: auto;
			}
			.qualificationQuery-search {
				width: $main-page-width;
				margin: 0 auto;
				padding: 20px;
			}
			.maintenance-list {
				width: $main-page-width;
				margin: 0 auto;
				padding: 20px;
				background-color: #ffffff;
				// box-shadow: 2px 7px 21px 0px rgba(57, 127, 212, 0.17);
				border-radius: 6px;
				border-top-left-radius: 0px;
				border-top-right-radius: 0px;
				margin-top: 20px;
				.notification-title {
					background-color: #f5f7fa;
					// border-bottom: 1px solid #ebeef5;
					padding: 12px 20px;
					margin-bottom: 8px;
					border-radius: 4px 4px 0 0;

					.title-text {
						color: #606266;
						font-size: 16px;
						font-weight: 500;

						.data-count {
							color: #409eff;
							font-size: 18px;
							font-weight: 600;
							margin: 0 4px;
						}
					}
				}
				.notification-item {
					justify-content: space-between;
					// 第三个元素也是margin-top：15px
					&:nth-child(3) {
						margin-top: 15px;
					}
				}
				.certificate-info {
					flex: 0 0 834px;
					.certificate-detail {
						align-items: flex-start;
						margin-bottom: 5px;
					}
					.certificate-name {
						span {
							margin-left: 10px;
						}
					}
					.detail-item {
						label {
							flex: none;
						}
						.detail-content {
							padding-right: 0px;
						}
					}

					.detail-item:nth-child(1) {
						flex: 0 0 310px;
					}
					.detail-item:nth-child(2) {
						flex: 0 0 381px;
					}
				}
				.certificate-status {
					flex-direction: row;
					span {
						width: 100px;
						height: 36px;
						background-color: #ffffff;
						border-radius: 18px;
						border: solid 1px #236fca;
						text-align: center;
						color: #236fca;
						font-size: 16px;
						margin-left: 10px;
						cursor: pointer;
						display: flex;
						justify-content: center;
						align-items: center;
						&:hover {
							color: #fff;
							background-color: #236fca;
							.icon {
								color: #fff !important;
							}
						}
					}
					.collect {
						.icon {
							margin-right: 5px;
							font-size: 18px;
						}
						.collected {
							color: #236fca;
						}
						&:hover {
							.icon {
								color: #236fca;
							}
						}
					}
				}
			}
		}
	}
</style>
